import { pubsub, cart } from '@services';
import { notyf } from '@modules';

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.quantityInput = this.form.querySelector('input[name="quantity"]');
    this.variantIdInput = this.form.querySelector('input[name="id"]');

    // Get all submit buttons that are part of the form
    this.submitButtons = document.querySelectorAll(
      `button[form="${this.form.getAttribute('id')}"]`
    );

    this.form.addEventListener('submit', (event) => this.onFormSubmit(event));

    this.unsubscribeVariantChange = pubsub.subscribe(
      `variant:changed:${this.dataset.productId}`,
      ({ html }) => {
        const productForm = html.querySelector('product-form').cloneNode(true);
        this.replaceWith(productForm);
      }
    );

    this.unsubscribeQuantityChange = pubsub.subscribe('quantity:change', ({ line, quantity }) => {
      if (line === undefined) this.quantityInput.value = quantity;
    });
  }

  disconnectedCallback() {
    this.unsubscribeVariantChange();
    this.unsubscribeQuantityChange();
  }

  /**
   * Handle form submission
   * @param {Event} event
   */
  async onFormSubmit(event) {
    event.preventDefault();
    this.toggleLoading(true);

    try {
      const items = [];

      // Check for upsell selection
      const upsellElement = this.querySelector('product-upsell');
      if (upsellElement && typeof upsellElement.getSelectedUpsellVariant === 'function') {
        const upsellVariantId = upsellElement.getSelectedUpsellVariant();
        if (upsellVariantId) {
          items.push({
            id: +upsellVariantId,
            quantity: 1,
          });
        }
      }

      await cart.add({ form: this.form, items });
    } catch (error) {
      this.onError(error);
    } finally {
      this.toggleLoading(false);
    }
  }

  /**
   * Toggle loading state on submit buttons
   * @param {boolean} loading
   */
  toggleLoading(loading) {
    this.submitButtons.forEach((button) => button.classList.toggle('loading', loading));
  }

  /**
   * Handle form error
   * @param {Error} error - The error object
   */
  onError({ message }) {
    notyf.error(message);
  }
}

customElements.define('product-form', ProductForm);
